/** Results / draw room (`/l/:slug/results`): signed static results + live tier reveal with the §4.4 ladder (outcome agent). */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const ResultsPage = lazyRoute(() => import('./ResultsPage'), 'page');

export const resultsRoutes: RouteObject[] = [{ path: 'results', element: <ResultsPage /> }];
